//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { GetAvailableLearnMoreResponse } from './models/GetAvailableLearnMoreResponse';
import { Utilities } from './Utilities';

export class LearnMoresClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getAvailableLearnMore: (
			detailed?: boolean,
			includeAll?: boolean,
        ): string => {
            let clientRequestUrl = '/api/v3/learn-mores?';
            if (detailed === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('detailed'));
            } else if (detailed !== undefined) {
                clientRequestUrl += `detailed=${encodeURIComponent(String(detailed))}&`;
            }
            if (includeAll === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('includeAll'));
            } else if (includeAll !== undefined) {
                clientRequestUrl += `includeAll=${encodeURIComponent(String(includeAll))}&`;
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        markAsReadLearnMore: (
			id: number,
        ): string => {
            let clientRequestUrl = '/api/v3/learn-mores/{id}/do-mark-as-read';
            if (id === undefined || id === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('id'));
            }
            clientRequestUrl = clientRequestUrl.replace('{id}', encodeURIComponent(String(id)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Retrieves all "Learn More" items available for the current user.
     * @param detailed (optional) 
     * @param includeAll (optional) 
     * @return OK
     */
    async getAvailableLearnMore(
        detailed?: boolean,
        includeAll?: boolean,
    ): Promise<GetAvailableLearnMoreResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getAvailableLearnMore(
            detailed,
            includeAll,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<GetAvailableLearnMoreResponse>(_response, false, ['lastUpdateDate', 'endDate']);
    }

    /**
     * Marks a "Learn More" item as read for the current user.
     * @param id The unique identifier of the "Learn More" item to mark as read.
     * @return No Content
     */
    async markAsReadLearnMore(
        id: number,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.markAsReadLearnMore(
            id,
        );

        const options = {
            method: 'POST',
            headers: {
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }
}
